var React = require('react');

function CloseSlim (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m23.874748,2.517164l-2.391914,-2.391913l-9.482835,9.482836l-9.482835,-9.482836l-2.391913,2.391913l9.482836,9.482835l-9.482836,9.482835l2.391913,2.391914l9.482835,-9.482836l9.482835,9.482836l2.391914,-2.391914l-9.482836,-9.482835l9.482836,-9.482835z"}));
}

CloseSlim.defaultProps = {"version":"1.1","id":"jw_icon","x":"0px","y":"0px","viewBox":"0 0 24 24","xmlSpace":"preserve"};

module.exports = CloseSlim;

CloseSlim.default = CloseSlim;
